import { Avatar } from "shared/types/avatar";
import { Gender } from "shared/types/common";
import { FileItemT, PhotoType } from "shared/types/media";

import { GENDER_FEMALE, GENDER_MALE } from "shared/constants";

import { getPictureWebpCompatible } from "shared/helpers/view";

import AvatarFemale from "assets/shared/img/ic_female.svg";
import AvatarMale from "assets/shared/img/ic_male.svg";

export const getAvatarThumbnailSrc = (
  avatar: Avatar | PhotoType | FileItemT | null = null,
  gender: Gender = GENDER_MALE
): string | null => {
  if (!avatar?.thumbnail || avatar?.empty) {
    return gender === GENDER_FEMALE ? AvatarFemale : AvatarMale;
  }

  return getPictureWebpCompatible(avatar, "thumbnail");
};
